import React from 'react';

/** A quiet printed mark; article dates and links remain real page content. */
export default function LetterPostmark() {
  return <svg className="letter-postmark" viewBox="0 0 112 58" fill="none" aria-hidden="true" focusable="false">
    <g stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 5h32v44H5Z" strokeDasharray="2 3" />
      <path d="M9 9h24v36H9Z" />
      <path d="M15 36c8-7 11-14 12-20m-8 16c-6-1-6-5-6-8 5 0 8 2 7 6m2-3c6-1 8-4 8-8-5 0-8 2-8 6" />
      <circle cx="61" cy="28" r="19" />
      <circle cx="61" cy="28" r="15" strokeDasharray="1 3" />
      <path d="M48 24h26m-23 7h20M78 18c8-5 16 5 27 0m-27 8c8-5 16 5 27 0m-27 8c8-5 16 5 27 0" />
    </g>
  </svg>;
}
